module.exports = __webpack_public_path__ + "static/media/mountain.c094c435.svg";